import HealthAdjuster from "./HealthAdjuster";

export default HealthAdjuster;
export { HealthAdjuster };
